import * as React from 'react';
import {Draggable} from 'react-beautiful-dnd';

import {DraggableRow} from 'shells/draggable-row/draggable-row';

import type {StagesetBasic as StagesetBasicFragment} from 'nutshell-graphql-types';

import {PipelineListItem} from './pipeline-list-item';

type Props = {
    index: number;
    stageset: StagesetBasicFragment;
};

function getDraggingStyle(isDragging: boolean, draggableStyle: any) {
    return {
        margin: '0 0 16px 0',
        // styles we need to apply on draggables
        ...draggableStyle,
    };
}

export class DraggablePipelineListItem extends React.PureComponent<Props> {
    render() {
        return (
            <Draggable index={this.props.index} draggableId={this.props.stageset.id}>
                {(draggableProvided, draggableSnapshot) => {
                    const style = getDraggingStyle(
                        draggableSnapshot.isDragging,
                        draggableProvided.draggableProps.style
                    );

                    return (
                        <div
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            style={style}
                        >
                            <DraggableRow dragHandleProps={draggableProvided.dragHandleProps}>
                                <PipelineListItem
                                    shouldPreventDragging={false}
                                    stageset={this.props.stageset}
                                />
                            </DraggableRow>
                        </div>
                    );
                }}
            </Draggable>
        );
    }
}
